export enum ProductStatus {
  Present = "present",
  Divergent = "divergent",
  NotCounted = "notCounted",
  NotFound = "notFound",
}
